module.exports = __webpack_public_path__ + "static/img/zhibo2.6abedc36.webp";